import { render, staticRenderFns } from "./GroupChannel.vue?vue&type=template&id=3cf74929&"
import script from "./GroupChannel.vue?vue&type=script&lang=js&"
export * from "./GroupChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports